/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
// @ts-nocheck
import React from "react"
import { Flex } from "@netdata/netdata-ui"

const Separator = () => <Flex height="1px" width="100%" background={["gray", "shuttleGray"]} />

export default Separator
